/*
 * File: \src\pages\notFound\index.js
 * Project: web
 * File Created: Tuesday, 24th March 2020 1:10:08 am
 */

import loadable from "@loadable/component";


export  default loadable(() => import("./NotFound")) 